/**
 * @fileoverview Deals page route for the Onicorn application
 * @module routes/deals
 */

import type { ReactElement } from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Deals layout component.
 *
 * Parent route component that renders child routes through an Outlet.
 * When on the main /deals route, shows the deals list with tabs.
 * When on /deals/$dealSlug, shows the individual deal details page.
 *
 * Uses TanStack Router's Outlet pattern for nested routing following
 * industry standards for SPA navigation.
 *
 * @component
 */
function DealsLayout(): ReactElement {
  return <Outlet />;
}


/**
 * Deals route configuration.
 *
 * Defines the parent deals route ('/deals') that handles both:
 * - Index route: displays the deals list with tabs
 * - Child routes: displays individual deal details via Outlet
 */
export const Route = createFileRoute('/deals')({
  component: DealsLayout,
});
